import { FETCH_DASHBOARD_STATS_FAIL, FETCH_DASHBOARD_STATS_REQUEST, FETCH_DASHBOARD_STATS_SUCCESS, FETCH_ORDERS_FAIL, FETCH_ORDERS_REQUEST, FETCH_ORDERS_SUCCESS, SET_ORDER, SET_ORDER_BY, SET_TAB_VALUE } from "../actions/DashboardActions";

// payment order reducer
const paymentorder = {
    loading: false,
    orders: [],
    error: null
};
export const paymentOrderReducer = (state = paymentorder, action) => {
    switch (action.type) {
        case 'ORDERS_REQUEST':
            return { ...state, loading: true };
        case 'ORDERS_SUCCESS':
            return { ...state, loading: false, orders: action.payload };
        case 'ORDERS_FAIL':
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};


const orderstate = {
    orders: [],
    loading: false,
    error: null,
    tabValue: 'All',
    orderBy: 'date',
    order: 'asc'
};

export const orderReducer = (state = orderstate, action) => {
    switch (action.type) {
        case FETCH_ORDERS_REQUEST:
            return { ...state, loading: true };
        case FETCH_ORDERS_SUCCESS:
            return { ...state, loading: false, orders: action.payload };
        case FETCH_ORDERS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case SET_TAB_VALUE:
            return { ...state, tabValue: action.payload };
        case SET_ORDER_BY:
            return { ...state, orderBy: action.payload };
        case SET_ORDER:
            return { ...state, order: action.payload };
        default:
            return state;
    }
};

const dashboardState = {
    data: null,
    loading: false,
    error: null
};

export const dashboardReducer = (state = dashboardState, action) => {
    switch (action.type) {
        case FETCH_DASHBOARD_STATS_REQUEST:
            return { ...state, loading: true };
        case FETCH_DASHBOARD_STATS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_DASHBOARD_STATS_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};